import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// material ui
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// component
import { EditCustomItemFormComponent } from './edit-custom-item-form.component';
import { HasClaimModule } from 'src/app/directives/has-claim/has-claim.module';
import { LoaderFormModule } from 'src/app/widgets/loaders/loader-form/loader-form.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HasClaimModule,
    LoaderFormModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    EditCustomItemFormComponent
  ],
  exports: [
    EditCustomItemFormComponent
  ],
  providers: [
  ]
})
export class EditCustomItemFormModule { }
